var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 35,
    viewBox: "0 0 50 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0.25C20.5425 0.25 16.5992 2.00142 13.768 4.44318C11.3745 6.50739 9.63998 9.19282 9.19446 11.8906C3.95582 13.0472 0 17.6097 0 23.1193C0 29.5187 5.33606 34.625 11.8164 34.625H39.6484C45.3198 34.625 50 30.1547 50 24.5398C50 19.4268 46.119 15.2628 41.1428 14.5593C40.3853 6.49824 33.407 0.25 25 0.25ZM32.3549 16.3326C32.965 16.9428 32.965 17.9322 32.3549 18.5424C31.7447 19.1525 30.7553 19.1525 30.1451 18.5424L26.5625 14.9597V26.8125C26.5625 27.6754 25.8629 28.375 25 28.375C24.1371 28.375 23.4375 27.6754 23.4375 26.8125V14.9597L19.8549 18.5424C19.2447 19.1525 18.2553 19.1525 17.6451 18.5424C17.035 17.9322 17.035 16.9428 17.6451 16.3326L23.8951 10.0826C24.5053 9.47245 25.4947 9.47245 26.1049 10.0826L32.3549 16.3326Z",
    fill: "#2162AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadIcon);
export default __webpack_public_path__ + "static/media/CloudUploadIcon.7696af04ad7f0bb05dfc24bcc94a0261.svg";
export { ForwardRef as ReactComponent };